module.exports = __webpack_public_path__ + "img/d0ec5ee.png";